import { MouseEvent, ReactNode } from 'react';

interface TableActionIconProps {
  title: string;
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

/** Round icon button for actions inside a table row, styled like the row's inquiry button. */
const TableActionIcon = ({ title, children, onClick, disabled = false }: TableActionIconProps) => {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      className="flex items-center justify-center p-1.5 rounded-full transition-colors enabled:hover:bg-(--surface-hover) disabled:cursor-not-allowed"
      style={{ color: disabled ? 'var(--font-disabled)' : 'var(--font-primary)' }}
    >
      {children}
    </button>
  );
};

export default TableActionIcon;
